import { Pipe, PipeTransform } from '@angular/core';

interface QuoteItemIndexPipeOptions {
  noTrailingDot?: boolean;
  skipLast?: boolean;
}

@Pipe({
  name: 'quoteItemIndex',
})
export class QuoteItemIndexPipe implements PipeTransform {
  transform(value: number[], options: QuoteItemIndexPipeOptions = {}): string {
    if (options.skipLast) {
      value = value.slice(0, -1);
    }
    return (
      value.join('.') + (value.length > 0 && !options.noTrailingDot ? '.' : '')
    );
  }
}
